import { useAuth } from "./authentication.provider";
import { PageLoader } from "../components/loaders";
import { Outlet, useLocation } from "react-router";
import { Navigate } from "react-router-dom";

export const ProtectedRouteProvider = () => {
    const context = useAuth();
    if (!context) throw new Error("AuthContext not found. Wrap your app with AuthProvider.");

    const { isAuthenticated } = context;
    const {pathname} = useLocation();

    const publicPaths = ["/sign-in", "/reset-password", "/create-account", "/set-new-password"];

    const isPublic = publicPaths.some(path => pathname.startsWith(path));

    if (!isAuthenticated && !isPublic) {
        return (
            <Navigate
                to={`/sign-in?redirect_to=${encodeURIComponent("/split-buy")}`}
                replace
            />
        );
    }

    return <Outlet />;
};

export const ProtectedForCartRouteProvider = () => {
    const { isAppInitialized, isAuthenticated, isGuestUser } = useAuth();

    if (!isAppInitialized) return <PageLoader />;

    if (!isAuthenticated && !isGuestUser) {
        return <Navigate to="/cart" replace />;
    }

    return <Outlet />;
};